import React from 'react';
import PropTypes from 'prop-types';

import ButtonDropdown from 'src/components/buttons/buttonDropdown/buttonDropdown';
import { DropdownItem } from 'reactstrap';

const PostFilterDropdown = ({ value, options, onChange }) => {
  return (
    <ButtonDropdown
      color="none"
      text={options[value]}
    >
      {Object.keys(options).map(filter => (
        <DropdownItem
          key={`post-filter-${filter}`}
          onClick={() => onChange(filter)}
        >
          {options[filter]}
        </DropdownItem>
      ))}
    </ButtonDropdown>
  );
};

PostFilterDropdown.propTypes = {
  options: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PostFilterDropdown;
